module.exports = __webpack_public_path__ + "static/media/basic-message.b9105ca6.png";